var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BGM_check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z",
    fill: "#3B4894"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7803 7.03033C11.0732 6.73744 11.0732 6.26256 10.7803 5.96967C10.4874 5.67678 10.0126 5.67678 9.71967 5.96967L7.25 8.43934L6.28033 7.46967C5.98744 7.17678 5.51256 7.17678 5.21967 7.46967C4.92678 7.76256 4.92678 8.23744 5.21967 8.53033L6.71967 10.0303C7.01256 10.3232 7.48744 10.3232 7.78033 10.0303L10.7803 7.03033Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputCheck);
export default __webpack_public_path__ + "static/media/input_check.d7b8f871c7d696759bafaac6a93b5c8d.svg";
export { ForwardRef as ReactComponent };